/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmResponsesListInputItems } from "../../funcs/llmResponsesListInputItems.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListInputItemsRequest$inboundSchema,
};

export const tool$llmResponsesListInputItems: ToolDefinition<typeof args> = {
  name: "llm-responses-list-input-items",
  description: `List paginated input items for a response

Retrieves a paginated list of all input items provided when creating the specified agent response.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmResponsesListInputItems(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
